export default "__VITE_ASSET__C1fPFDYD__"